<template>
  <div class="login-normal-container">
    <form class="form-login" name="form-login" @submit.prevent="loginv2">
      <!-- Error Alert anchor -->
      <div class="errors">
        <div ref="alert"></div>
      </div>
      
      <div class="form-login-container">
        <!-- User field -->
        <div class="form-group-modern">
          <label class="label-modern" for="usuario">{{ $t('message.login_text_user') }}</label>
          <div class="input-wrapper-modern">
            <input 
              type="text" 
              id="usuario" 
              name="usuario" 
              v-model="username" 
              v-validate="{ required: true, regex: /^[a-zA-Z0-9_]{1,32}$/ }" 
              data-vs-input="user-input"
              class="input-modern"
              placeholder="Ingrese su usuario"
              autocomplete="username"
            />
          </div>
          <span class="error-message-modern" v-show="errors.has('usuario')">
            {{ errors.first('usuario') }}
          </span>
        </div>

        <!-- Password field -->
        <div class="form-group-modern">
          <label class="label-modern" for="password">{{ $t('message.login_text_password') }}</label>
          <div class="input-wrapper-modern" style="position: relative !important; width: 100% !important;">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              id="password" 
              name="password" 
              v-model="password" 
              v-validate="'required'" 
              data-vs-input="pass-input"
              class="input-modern"
              placeholder="Ingrese su contraseña"
              autocomplete="current-password"
              style="padding-right: 48px !important;"
            />
            <button 
              type="button" 
              class="password-toggle-btn"
              @click="showPassword = !showPassword"
              style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: transparent; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; outline: none; padding: 4px; z-index: 10;"
            >
              <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
          <span class="error-message-modern" v-show="errors.has('password')">
            {{ errors.first('password') }}
          </span>
        </div>

        <!-- Actions / Submit Buttons -->
        <div class="form-actions-modern">
          <input 
            v-if="buttonLoginDisable" 
            type="submit" 
            id="m_login_signin_submit"
            class="btn-modern btn-submit-modern" 
            value="Ingresar" 
            data-vs-button="button-login-disable"
          />
          <input 
            v-else 
            id="m_login_signin_submit" 
            type="submit" 
            class="btn-modern btn-submit-modern btn-loading-modern"
            value="Cargando..." 
            data-vs-button="button-login-submit" 
            disabled 
          />
          
          <button 
            v-if="sso" 
            type="button" 
            class="btn-modern btn-sso-modern" 
            data-vs-button="button-login-sso"
            @click.prevent="loginSSO"
          >
            Ingresar con Single Sign On
          </button>
        </div>

        <!-- Forgot password -->
        <div class="form-footer-modern">
          <a 
            href="javascript:;" 
            id="m_login_forget_password" 
            class="link-modern"
            data-vs-button="button-login-forget-pass" 
            @click="clickForgetPass"
          >
            {{ $t('message.login_text_forgot_password') }}
          </a>
          <a 
            href="javascript:;" 
            id="handlerModalRelated" 
            data-toggle="modal"
            data-vs-button="button-login-active-modal-related" 
            data-target="#switch-user"
          ></a>
        </div>

        <!-- Sichern Connect -->
        <div v-if="sichernConnectActive" class="sichern-connect-section-modern">
          <div class="divider-modern">
            <span>{{ $t('message.login_text_or') }}</span>
          </div>
          <button
            type="button"
            class="btn-modern btn-connect-modern"
            @click.prevent="getSichernConnectURL"
          >
            <span class="connect-icon-modern">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
                <path d="M10.3201 7.63867C13.1529 7.9054 16.2374 9.37652 18.0002 11.5818C20.2662 14.323 19.5096 17.0653 16.2374 17.7319C13.0267 18.4004 8.55733 16.6607 6.29092 13.9213C4.59127 11.8499 4.59127 9.70967 6.16508 8.57383L15.1042 15.5924L10.3201 7.63867Z" fill="#FF0540"/>
              </svg>
            </span>
            {{ $t('message.login_text_sichern_connect') }}
          </button>

          <a 
            href="https://sichernsa.freshdesk.com/support/solutions/13000005641"
            target="_blank"
            rel="noopener noreferrer"
            class="connect-faq-link-modern"
          >
            {{ $t('message.login_text_faq_sichern_connect') }}
          </a>
        </div>
      </div>
    </form>
    
    <!-- Legacy Right Column (Hidden by SCSS) -->
    <div class="col-lg-6 col-md-6 mobile-hide desktop-show-logo">
      <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
      <div v-else>
        <img :src="`${baseUrl}assets/images/background-login.png`" class="logo-desktop-noChrome" />
      </div>
    </div>
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import axios from 'axios';
import Auth from '../../apiClient/Auth';
import User from '../../apiClient/User';
import Actions from '../../apiClient/Actions';
import Alert from '../../components/generics/Alert.vue';
import MFA from '../../apiClient/Mfa';
import Config from '@/config/index';
import { mapActions, mapGetters } from 'vuex';
import { filter, isEmpty, has, find, map, remove } from 'lodash';
import moment from 'moment';

export default {
  components: {
    Alert,
  },
  props: {
    parentData: String,
  },
  data() {
    return {
      forgetpass: false,
      buttonLoginDisable: true,
      username: '',
      password: '',
      showPassword: false,
      tkn: '',
      jwt: '',
      usersRelated: [],
      alertMoment: true,
      requireEmailValidate: false,
      $refs: {
        alert: HTMLElement,
      },
      baseUrl: process.env.VUE_APP_BASE,
      form: {},
      employeeRelated: {},
      userRelatedEmpty: false,
      codePasswordExpired: '',
      ipAddressNotAllowed: '',
      sichernConnectActive: false
    };
  },
  created() {
    this.auth = new Auth();
    this.user = new User();
    this.MFA = new MFA();
  },
  computed: {
    ...mapGetters(['getSSOData']),
    sso() {
      return !isEmpty(this.getSSOData);
    }
  },
  methods: {
    ...mapActions({
      setParamLoginFactory: 'setParamLoginFactory',
    }),
    errorMessage(msg) {
      const ComponentClass = Vue.extend(Alert);
      const instance = new ComponentClass({
        propsData: {
          role: 'danger',
          title: 'Error',
          message: this.$t('message.error_' + msg),
          stay: true,
        },
      });
      if (msg === 'not_onboarding') {
        let createHref = this.$createElement('a', {
          attrs: {
            name: 'sichern.com',
            href: 'https://sichern.com',
            target: '_blank',
          },
          domProps: {
            innerHTML: 'sichern.com',
          },
          style: {
            fontWeight: 'bold',
          },
        });
        instance.$slots.default = [createHref];
      }
      instance.$mount();
      this.$refs.alert.replaceChildren(instance.$el);
    },
    showPassword(id) {
      if (this.showPass) {
        this.showPass = false;
        document.getElementById(id).setAttribute('type', 'password');
      } else {
        this.showPass = true;
        document.getElementById(id).setAttribute('type', 'text');
      }
    },
    clickForgetPass() {
      this.$emit('clickForgetPass', true);
    },
    cleanUserRelated() {
      this.usersRelated = [];
    },
    async loginv2() {
      const result = await this.$validator.validate();
      if (!result) {
        return;
      }

      this.alertMoment = JSON.parse(localStorage.getItem('alertMoment'));
      this.buttonLoginDisable = !this.buttonLoginDisable;
      //Autenticacion comun /auth
      this.cleanUserRelated();

      try {
        let userTrim = this.username.trim();
        const res = await this.auth.login(userTrim, this.password);
        if (has(res, 'data')) {
          const { status, data } = res;
          this.$emit('user', userTrim);
          this.$emit('password', this.password);
          this.$emit('jwt', data.jwt);
          localStorage.jwt = data.jwt;
          this.$store.commit('CLEAR_PROFILE');
          
          // Si hay MFA pendiente (códigos 00600 o 00606), skip performance check
          const hasMFAPending = data.code === '00600' || data.code === '00606';
          let profileUserData = await this.$store.dispatch('getProfile', { 
            skipPerformanceCheck: hasMFAPending 
          });
          const { factory } = this.$route.query;

          switch (data.code) {
            case '00606':
              ///////////// caso MFA activo , y sin correo registrado
              await this.managerUserRelated();
              if (this.userRelatedEmpty) {
                this.buttonLoginDisable = !this.buttonLoginDisable;
                if (this.alertMoment) {
                  this.errorMessage('rrhh');
                }
                localStorage.jwt = null;
                await this.$store.dispatch('setJwt', { token: null });
                return false;
              }
              this.$emit(
                'loginEmailValidation',
                profileUserData.mail != null ? profileUserData.mail : ''
              );
              this.$emit('launchEmailValidation', true);
              break;
            case '00600':
              ///////////// caso MFA activo , y con correo registrado y verificado
              await this.managerUserRelated();
              if (this.userRelatedEmpty) {
                this.buttonLoginDisable = !this.buttonLoginDisable;
                if (this.alertMoment) {
                  this.errorMessage('rrhh');
                }
                localStorage.jwt = null;
                await this.$store.dispatch('setJwt', { token: null });
                return false;
              }
              this.MFA.getResendStatus()
                .then(() => {
                  //response 200 retorna tiempo de bloqueo e indica bloqueo MFA
                  this.$emit('exceededFailsAuth', 'maxResendFails');
                })
                .catch(() => {
                  //response 400 error indica que no hay bloqueo MFA
                  this.$emit('loginEmailValidation', profileUserData.mail); //emit user email
                  this.$emit('requiredValidationMFA', data);
                });
              break;
            case '00015':
              const authResponse = await this.user.passwordPoliciesV2();
              this.$emit('passwordPolicies', authResponse.data);
              const firstLoginResponse = await this.user.firstlogin();
              if (has(firstLoginResponse.data.results, 'data')) {
                this.$emit('firstLoginToken', firstLoginResponse.data.results.data[0]);
                this.$emit('firstLogin', true);
              }
              if (this.employeeRelated.mail !== '') {
                this.$emit('firstLoginEmail', this.employeeRelated.mail);
              }
              break;
            default:
              //seleccionamos el usuario con ultima sesion
              await this.managerUserRelated();

              if (this.userRelatedEmpty) {
                this.buttonLoginDisable = !this.buttonLoginDisable;
                if (this.alertMoment) {
                  this.errorMessage('rrhh');
                }
                localStorage.jwt = null;
                await this.$store.dispatch('setJwt', { token: null });
                return false;
              }
              if (parseInt(factory, 10) === this.employeeRelated.empresa.id) {
                this.setParamLoginFactory(factory);
                this.$route.query.factory = '';
              }

              var termine = false;
              while (!termine) {
                if (this.employeeRelated)
                  await this.onSwitch(this.employeeRelated.id, data.jwt);

                if (this.codePasswordExpired === '00607') {
                  this.$emit('passwordExpired');
                  await this.$store.dispatch('resetStore');
                  return false;
                }

                if (this.ipAddressNotAllowed === '00609') {
                  if (this.usersRelated.length === 1) {
                    this.errorMessage(401);
                    this.buttonLoginDisable = !this.buttonLoginDisable;
                    localStorage.jwt = null;
                    await this.$store.dispatch('resetStore');
                    return false;
                  } else {
                    this.removeUserRelated();
                    this.ipAddressNotAllowed = '';
                    this.employeeRelated = this.findDateLastSessionUser(
                      this.usersRelated
                    );
                    continue;
                  }
                }

                termine = true;
              }

              if (profileUserData.estado_empresa === 2) {
                this.errorMessage('not_onboarding');
                this.buttonLoginDisable = !this.buttonLoginDisable;
                localStorage.jwt = null;
                await this.$store.dispatch('setJwt', { token: null });
                return false;
              }

              await this.$store.dispatch('setSearchRRHH', { search: {} });
              await this.getActionsAndLoginPhp(this.employeeRelated, data.jwt, true);
              if (status === 'error') {
                if (this.alertMoment) {
                  this.errorMessage(data.results.data[0]);
                }
              }
              break;
          }
        }
      } catch (error) {
        this.buttonLoginDisable = !this.buttonLoginDisable;
        if (error.response.data.code === '00018' && this.alertMoment) {
          this.errorMessage(error.response.data.code);
        } else if (error.response.status === 402 && this.alertMoment) {
          this.errorMessage(error.response.data.code);
        } else {
          if (error.response.status === 401 && this.alertMoment) {
            this.errorMessage(error.response.status);
          }
        }
      }
    },
    loginSSO(event) {
      const subDomain = location.hostname.split('.')[0];
      const subDomainFirstDot = location.hostname.indexOf('.');
      const domain = location.hostname.substring(
        subDomainFirstDot === -1 ? 0 : subDomainFirstDot + 1
      );
      const baseUrl = `${subDomain}-${this.getSSOData.company}.${domain}`;
      location.replace(`https://${baseUrl}/sso`);
      event.stopPropagation();
    },
    async getActionsAndLoginPhp(usuario, tkn, noRelated) {
      if (noRelated) {
        await this.$store.dispatch('setJwt', { token: tkn });
        await this.$store.dispatch('setUser', { user: usuario });
      }
      let actions = new Actions();
      await actions.getActions().then(async (result) => {
        let res = result.status === 200 ? result.data.results.data : [];
        let fil = map(res, function (n) {
          return Number(n.id);
        });
        await this.$store.dispatch('setPermissions', {
          permissions: fil,
        });

        /*const bodyFormData = new FormData();
        bodyFormData.append("login", true);
        bodyFormData.append("usuario", this.username);
        bodyFormData.append("clave", this.password);
        if (this.$route.query.hasOwnProperty("ref"))
          bodyFormData.append("ref", `${this.$route.query.ref}`);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        await axios
          .post(location.origin + `/login`, bodyFormData, config)
          .then((result) => {
            if (result.data.hasOwnProperty("ref"))
              window.location = result.data.ref;
            else this.$router.push("/home");
          })
          .catch((error) => {
            console.error("Error login PHP", error);
          });
          */
        if (this.$store.getters.isActionAllowed(305)) {
          await this.$store.dispatch('setNewDocumentWaiting')
        } else {
          await this.$store
            .dispatch('setDocumentsWaiting', {
              perPage: 10,
              page: 1,
              orderParams: null,
            })
            .catch((err) => { });
        }
        this.$router.push('/home');

        
      });
    },
    async removeUserRelated() {
      remove(this.usersRelated, (user) => {
        return JSON.stringify(user) === JSON.stringify(this.employeeRelated);
      });
    },
    async managerUserRelated() {
      const responseRelated = await this.user.relatedUsers();
      this.usersRelated = filter(responseRelated.data.results.data, (userRelated) =>
        find(
          userRelated.perfiles,
          (profile) => profile.id_perfil_tipo === 2 || profile.id_perfil_tipo === 7 || profile.id_perfil_tipo === 8
        )
      );
      isEmpty(this.usersRelated)
        ? ((this.userRelatedEmpty = true), (this.alertMoment = true))
        : (this.userRelatedEmpty = false);
      this.$emit('usersRelated', this.usersRelated);
      this.employeeRelated = this.findDateLastSessionUser(this.usersRelated);
    },
    findDateLastSessionUser(listUserRelated) {
      let userWithOutLastSession = find(listUserRelated, (userRelated) =>
        isEmpty(userRelated.ultimasession)
      );
      let LastSessionUser = new Date(
        Math.max.apply(
          null,
          map(listUserRelated, (userLastSession) => {
            if (!isEmpty(userLastSession.ultimasession)) {
              return new Date(
                moment(userLastSession.ultimasession, 'DD-MM-YYYY hh:mm:ss').format()
              );
            } else return '';
          })
        )
      );
      let userWithLastSession = filter(
        listUserRelated,
        (userLastSession) =>
          new Date(
            moment(userLastSession.ultimasession, 'DD-MM-YYYY hh:mm:ss').format()
          ).getTime() === LastSessionUser.getTime()
      )[0];
      return userWithOutLastSession ? userWithOutLastSession : userWithLastSession;
    },
    async onSwitch(selected, jwt) {
      this.ipAddressNotAllowed = '';
      this.codePasswordExpired = '';
      let user = '';
      await this.user.switchUser(selected).then((response) => {
        if (response.data.code === '00607') {
          this.codePasswordExpired = response.data.code;
          return false;
        }
        if (response.data.code === '00609') {
          //no estoy en las IPS
          this.ipAddressNotAllowed = response.data.code;
          return false;
        }
        localStorage.setItem('user', JSON.stringify(response.data.results.data[0]));
        user = response.data.results.data[0];
      });
      const config = {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      };

      let fromData = new FormData();
      fromData.append('userid', selected);

      await axios
        .post(location.origin + `/switch.user`, fromData, config)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$store.dispatch('setJwt', { token: jwt });
            this.$store.dispatch('setUser', { user: user });
            let actions = new Actions();
            actions.getActions(true).then((result) => {
              let res = result.status === 200 ? result.data.results.data : [];
              let fil = map(res, function (n) {
                return Number(n.id);
              });
              this.$store.dispatch('setPermissions', {
                permissions: fil,
              });
            });
          }
        });
    },
    validateAutofill() {
      setTimeout(() => {
        let isAutofill = document.querySelectorAll(':-webkit-autofill');
        if (isAutofill.length === 0) return;
        let elms = document.querySelectorAll('.zt-input-main');
        for (let i = 0; i < elms.length; i++) {
          let inputLabel = elms[i].querySelectorAll('label')[0];
          inputLabel.classList.add('zt-label-active');
        }
      }, 500);
    },
    getSichernConnectURL() {
      window.location.href = window.location.origin + '/sichern-connect';
    }
  },
  mounted() {
    this.validateAutofill();
    this.sichernConnectActive = window.localStorage.getItem('vc_demo') === '1';
  },
};
</script>

<style scoped lang="scss">
@import './login.scss';
@import './login-modern.scss';

::v-deep .input-custom {
  .zt-label {
    font-weight: 400;
    color: #4f4f4f;
  }
}

.login-sso {
  margin-top: 1.5rem;
}

.sichern-connect {
  border: solid 1px #6F6F6F !important;
  background: #f2f3f8;
}
.sichern-connect:hover {
  background: #e0e1e6;
}
.sichern-connect-faq {
  font-family: Roboto, sans-serif;
}
.login-normal-container {
  margin-top: 3rem !important;
}
@media (max-height: 768px) {
  .login-normal-container {
    margin-top: 2rem !important;
  }
  .username-password-container div {
    margin-top: 2rem !important;
  }
}
</style>
